export default __webpack_public_path__ + "static/media/icon-console.2dc6019e.svg";